import * as types from '../actions/action-types';

export const initialState = {
  countries: [],
  values: {},
};

const billingAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.BILLING_ADDRESS_SET_COUNTRIES:
      return {
        ...state,
        countries: action.countries,
      };
    case types.BILLING_ADDRESS_UPDATE:
      return {
        ...state,
        values: {...state.values, ...action.payload},
      };
    case types.BILLING_ADDRESS_OVERWRITE:
      return {
        ...state,
        values: {...action.payload},
      };
    case types.ADDRESS_LOOKUP_USE_BILLING_RESULT:
      return {
        ...state,
        values: {
          country: state.values.country,
          ...action.values,
          showLookupSelection: true,
        },
      };
    default:
      return state;
  }
};

export default billingAddressReducer;
